import {SettingsCustomFieldsPagesEnum} from '../../../../models/url/settingsUrlModel';
import {
  baseMethods,
  BooleanResult,
  EmailResult,
  GetCustomField,
  ResultType,
  ResultTypesEnum,
  StringResult,
} from './internal';

export const teammateType: ResultType = {
  name: ResultTypesEnum.TEAMMATE,
  properties: {
    id: StringResult,
    full_name: StringResult,
    first_name: StringResult,
    last_name: StringResult,
    username: StringResult,
    email: EmailResult,
    is_available: BooleanResult,
    is_global_admin: BooleanResult,
    is_visitor: BooleanResult,
  },
  methods: {
    get_custom_field: new GetCustomField(SettingsCustomFieldsPagesEnum.TEAMMATES),
    ...baseMethods,
  },
};
